import { Button, HStack, Menu, MenuButton, MenuDivider, MenuItem, MenuList, Spinner, Text } from '@chakra-ui/react'
import { AddUserDialog } from './AddUserDialog'
import { IUserInfo } from '@/shared/IUserInfo';
import React from 'react';
import { FiChevronDown, FiPlus } from 'react-icons/fi';

export const AddUserButton = (props: {
  availableUsers: IUserInfo[];
  enableAdd?: boolean;
  onAddUser: (user: IUserInfo, invite: boolean) => Promise<any>;
  title: string;
  description: string;
}) => {

  const [showUserDialog, setShowUserDialog] = React.useState(false);
  const [isAdding, setIsAdding] = React.useState(false);

  const onAddExistingUser = async (user: IUserInfo) => {
    try {
      setIsAdding(true);
      await props.onAddUser(user, false);
    } finally {
      setIsAdding(false);
    }
  }

  return (
    <>
      <Menu>
        <MenuButton rightIcon={isAdding ? undefined : <FiChevronDown />} minW={24} size='sm' as={Button} isDisabled={isAdding} variant='ghost'>
          <HStack spacing={3}>{isAdding && <Spinner size='sm' />}<Text>Select</Text></HStack>
        </MenuButton>
        <MenuList>
          {props.enableAdd && <>
            <MenuItem key='NewUser' icon={<FiPlus />} onClick={() => setShowUserDialog(true)}>
              New User...
            </MenuItem>
          </>}
          {props.enableAdd && props.availableUsers.length > 0 && <MenuDivider />}
          {props.availableUsers.map((user) => (
            <MenuItem key={user.id} onClick={() => onAddExistingUser(user)}>
              {user.name} ({user.email})
            </MenuItem>
          ))}

        </MenuList>
      </Menu>
      {showUserDialog && <AddUserDialog
        onClose={() => setShowUserDialog(false)}
        onSave={props.onAddUser}
        title={props.title}
        description={props.description}
        saveLabel='Add User'
        savingLabel='Adding User...'
      />}
    </>
  )
}